import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  cancelReasons: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the cancelReasons
export const fetchCancelReasons = createAsyncThunk(
  "fetchCancelReasons/cancelReasons",
  async ({ enqueueSnackbar, limit = 100, page = 0, filter }, thunkApi) => {
    try {
      const response = await axiosInstance.get(
        `settings/cancellation-reasons`,
        {
          params: {
            page: page + 1,
            limit,
            ...(filter &&
              filter.user_type && {
                user_type: filter.user_type,
              }),
          },
        }
      );

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create cancelReason
export const createCancelReason = createAsyncThunk(
  "createCancelReason/cancelReasons",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(
        `settings/cancellation-reasons`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update cancelReason
export const updateCancelReason = createAsyncThunk(
  "updateCancelReason/cancelReasons",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `settings/cancellation-reasons/${id}`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete cancelReason
export const deleteCancelReason = createAsyncThunk(
  "deleteCancelReason/cancelReasons",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`settings/cancellation-reasons/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const cancelReasonslice = createSlice({
  name: "cancelReason",
  initialState,
  extraReducers: (builder) => {
    // TODO: create cancelReason
    builder.addCase(fetchCancelReasons.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchCancelReasons.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.cancelReasons = action.payload;
    });

    builder.addCase(fetchCancelReasons.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create cancelReason
    builder.addCase(createCancelReason.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createCancelReason.fulfilled, (state, action) => {
      state.isLoading = false;
      state.cancelReasons.data = [
        action.payload.data,
        ...state.cancelReasons.data,
      ];
      state.cancelReasons.meta.total = state.cancelReasons.meta.total + 1;
      action.payload.enqueueSnackbar("CANCELREASON is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createCancelReason.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update cancelReason
    builder.addCase(updateCancelReason.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateCancelReason.fulfilled, (state, action) => {
      state.isLoading = false;
      state.cancelReasons.data = state.cancelReasons.data.map(
        (cancelReason) => {
          if (cancelReason.id === action.payload.data.id) {
            return action.payload.data;
          } else {
            return cancelReason;
          }
        }
      );
      action.payload.enqueueSnackbar("CANCELREASON is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateCancelReason.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete cancelReason
    builder.addCase(deleteCancelReason.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteCancelReason.fulfilled, (state, action) => {
      state.isLoading = false;
      state.cancelReasons.data = state.cancelReasons.data.filter(
        (cancelReason) => cancelReason.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("CANCELREASON is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteCancelReason.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default cancelReasonslice.reducer;
